import React, {useState} from 'react';

interface UseImageCarouselParams {
  totalImages: number;
}

/**
 * Manages carousel state (active slide index) and navigation handlers
 * for a location image carousel.
 *
 * Navigation is clamped to [0, totalImages - 1] so consumers do not need
 * to guard against underflow or overflow themselves. Each handler also stops the
 * click, so an arrow on a card never opens the card (its link or its onClick).
 *
 * @param totalImages - Total number of images in the carousel.
 */
export function useImageCarousel({ totalImages }: UseImageCarouselParams) {
  const [activeSlide, setActiveSlide] = useState(0);

  const prevImage = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setActiveSlide(prev => Math.max(0, prev - 1));
  };

  const nextImage = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setActiveSlide(prev => Math.min(totalImages - 1, Math.max(0, prev + 1)));
  };

  return { activeSlide, prevImage, nextImage };
}


